import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import SVG from '../SVG';
import { Colours } from '../../tokens';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
const PlusIcon = ({ className }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 24 24", className: classNames(styles.root, className) },
        React.createElement("line", { x1: "2", y1: "12", x2: "22", y2: "12", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px" }),
        React.createElement("line", { x1: "12.1", y1: "22", x2: "12.1", y2: "2", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px" })));
};
export default PlusIcon;
//# sourceMappingURL=PlusIcon.js.map